import React, { useState, useEffect } from "react";
import auth from "services/auth";
import { Redirect, Route, Link, useLocation } from "react-router-dom";
import Translator, { __ } from "services/Translator";

const StickyFooterMenu = (props) => {
  const [isAuthenticated, setIsAuthenticated] = useState(auth.isAuthenticated);
  const [showWalletModal, setShowWalletModal] = useState(false);
  useEffect(() => {
    // alert(showWalletModal)
    if (showWalletModal == true) {
      props.showWalletModal(showWalletModal);
    }
  }, [showWalletModal]);

  const handleChatToggle = () => {
    if (typeof window.Tawk_API !== "undefined") {
      window.Tawk_API.toggle();
    } else {
      console.error("Tawk_API is not available.");
    }
  };
  //Search functionality
  const [showSearch, setShowSearch] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const updateSearchInput = (ev) => {
    var target = ev.target;
    var field = target.name;
    var value = target.value;
    setSearchVal(value);
  };

  // useEffect(() => {
  //   props.searchVal(searchVal);
  // }, [searchVal]);

  //GamePlay Page detection
  const location = useLocation();

  const [showSlotsLink, setShowSlotsLink] = useState(false);

  useEffect(() => {
    const playPath = location.pathname.split("/");
    setShowSlotsLink(playPath.includes("live-casino"));
  }, [location]);

  const setSupportSidebarOpen = props.setSupportSidebarOpen;
  const supportSidebarOpen = props.supportSidebarOpen;
  const toggleSupportSidebar = () => {
    setSupportSidebarOpen(!supportSidebarOpen);
    props.setShowRightSidebar(false);
  };

  return (
    <>
      <section className="stickyMenu">
        <div className="nav-bar">
          <button
            type="button"
            onClick={() => {
              props.setIsSidebarCollapsed(!props.isSidebarCollapsed);
              props.setShowLeftSidebar(!props.showLeftSidebar);
            }}
            className="nav-item"
          >
            <div className="icon">
              <img
                alt=""
                src={
                  require("../assets/play365/images/stickyFooter/menu.svg")
                    .default
                }
              />
            </div>
            <span>{__("Menu")}</span>
          </button>
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            to="/games/all"
            onClick={() => {
              props.setShowLeftSidebar(false);
              props.setIsSidebarCollapsed(true);
            }}
            className={"nav-item " + (location.pathname == "/" ? "" : "")}
          >
            <div className="icon">
              <img
                alt=""
                src={
                  require("../assets/play365/images/stickyFooter/games.svg")
                    .default
                }
              />
            </div>
            <span>{__("Games")}</span>
          </Link>
          {!props.isAuthenticated ? (
            <button
              type="button"
              onClick={() => {
                props.setModalSignUpPropsData(true);
                props.setShowLeftSidebar(false);
                props.setIsSidebarCollapsed(true);
                setTimeout(function () {
                  props.setModalSignUpPropsData(false);
                }, 500);
              }}
              className="nav-item middleBtn"
            >
              <div className="middleItem">
                <div className="icon">
                  <img
                    alt=""
                    src={
                      require("../assets/play365/images/stickyFooter/play.svg")
                        .default
                    }
                  />
                </div>
                <span>{__("Play")}</span>
              </div>
            </button>
          ) : (
            <button
              type="button"
              onClick={() => {
                if (typeof props.setOpenWalletModalTab === "function") {
                  props.setOpenWalletModalTab("deposit");
                }
                props.setShowLeftSidebar(false);
                props.setIsSidebarCollapsed(true);
              }}
              className="nav-item middleBtn"
            >
              <div className="middleItem">
                <div className="icon">
                  <img
                    alt=""
                    style={{ width: "25px" }}
                    src={
                      require("../assets/play365/images/stickyFooter/buy.svg")
                        .default
                    }
                  />
                </div>
                <span>{__("Buy")}</span>
              </div>
            </button>
          )}
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            to="/promotions"
            className={"nav-item "}
            onClick={() => {
              props.setShowLeftSidebar(false);
              props.setIsSidebarCollapsed(true);
            }}
          >
            <div className="icon">
              <img
                alt=""
                src={
                  require("../assets/play365/images/stickyFooter/coupon.svg")
                    .default
                }
              />
            </div>
            <span>{__("Promo")}</span>
          </Link>
          <button
            type="button"
            onClick={() => {
              toggleSupportSidebar();
              props.setShowLeftSidebar(false);
              props.setIsSidebarCollapsed(true);
            }}
            className="nav-item"
          >
            <div className="icon">
              <img
                alt=""
                src={
                  require("../assets/play365/images/stickyFooter/liveChat.svg")
                    .default
                }
              />
            </div>
            <span>{__("Livechat")}</span>
          </button>
        </div>
      </section>
    </>
  );
};

export default StickyFooterMenu;
